import gql from "graphql-tag";

export default gql`
  mutation updateUser(
    $id: Int!
    $firstname: String
    $lastname: String
    $email: String
    $profilePictureUrl: String
  ) {
    updateUserById(
      input: {
        id: $id
        userPatch: {
          firstname: $firstname
          lastname: $lastname
          email: $email
          profilePictureUrl: $profilePictureUrl
        }
      }
    ) {
      clientMutationId
      user {
        id
        email
        firstname
        lastname
        profilePictureUrl
      }
    }
  }
`;
